import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class ValuesListService {
    static ENV = environment;

    constructor(private httpService: HttpService) {
        HEADERS['Content-Type'] = 'application/json';
    }

    public getLookupsTypes(httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.get(ValuesListService.ENV.environment.API.get_lookups_types, httpRequesthandler);
    }

    public getLookupsValues(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(ValuesListService.ENV.environment.API.get_lookups_values, data, httpRequesthandler);
    }

    public createLookupsValues(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(ValuesListService.ENV.environment.API.create_lookups_values, data, httpRequesthandler);
    }

    public deleteLookupsValues(lookup_code: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.delete(`${ValuesListService.ENV.environment.API.lookups_values}/${lookup_code}`,  httpRequesthandler);
    }

    public saveLookupsType(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(ValuesListService.ENV.environment.API.lookups_types, data, httpRequesthandler);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/admin/values-list.service.ts